import { styled } from 'styled-components'

export const BoardLayout = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  min-height: 851px;
`

export const Column = styled.div<{ $wide?: boolean }>`
  flex: ${({ $wide }) => ($wide ? 2 : 1)};
  min-width: ${({ $wide }) => ($wide ? 520 : 320)}px;
  max-height: 851px;
  background: var(--color-bg);
  border: 1px solid var(--color-border-primary);
  border-radius: 6px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const ColumnHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  border: 1px solid var(--color-border-primary);
  border-radius: 6px;
  padding: 6px 10px;
  background: var(--color-bg);
  flex-shrink: 0;
`

export const ColumnTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: var(--color-text-primary);
`

export const ColumnCount = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: var(--color-text-primary);
`

export const ColumnContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  flex: 1;
  padding-bottom: 8px;
`

const PATIENT_NAME_COL_WIDTH = 120
const AVATAR_SIZE = 48

export const OrderCard = styled.div`
  display: grid;
  grid-template-columns: ${AVATAR_SIZE}px minmax(0, ${PATIENT_NAME_COL_WIDTH}px) minmax(0, 1fr);
  gap: 0 16px;
  padding: 8px;
  border-radius: 6px;
  background: var(--color-bg);
  box-shadow: var(--shadow-box);
  align-items: center;
`

export const PatientAvatarShell = styled.div`
  width: ${AVATAR_SIZE}px;
  height: ${AVATAR_SIZE}px;
  border-radius: 6px;
  background: var(--color-primary);
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const PatientBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`

export const PatientAvatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
`

export const PatientText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`

export const PatientName = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: var(--color-text-primary);
  line-height: 1.2;
  text-transform: capitalize;
  word-break: break-word;
`

export const PatientItemCount = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: var(--color-text-primary);
  opacity: 0.7;
`

export const ItemsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 24px;
  row-gap: 12px;
  width: 100%;
  min-width: 0;
`

export const ProductChip = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  width: 100%;
`

export const ProductDetails = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex: 1;
  min-width: 0;
`

export const ProductThumb = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 4px;
  object-fit: cover;
  flex-shrink: 0;
`

export const ProductThumbPlaceholder = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background: #f3f3f3;
  flex-shrink: 0;
`

export const ProductName = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: var(--color-text-primary);
  line-height: 1.2;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ProductQty = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: var(--color-text-primary);
  flex-shrink: 0;
  min-width: 12px;
  text-align: right;
`

export const InventoryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 56px;
  padding: 8px 12px;
  border-radius: 6px;
  background: var(--color-bg);
  box-shadow: var(--shadow-box);
`

export const InventoryLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`

export const InventoryName = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: var(--color-text-primary);
  line-height: 1.2;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const InventoryQty = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: var(--color-text-primary);
  flex-shrink: 0;
`

export const EmptyState = styled.p`
  font-size: 14px;
  color: var(--color-text-primary);
  opacity: 0.6;
  margin: 8px 0 0;
`
